import {Link} from 'react-router-dom';
import PrintAttendance from "../../printAttendance";
import './style.scss';

function MeetingRow({school, meetingGroup}) {

    function setDate(meetingDate){
        if (meetingDate) {
            const index = meetingDate.indexOf('T');
            if (index !== -1) {
                return meetingDate.substring(0, index);
            }
        }
        return '';
    }

    return (
        <div className='info-container'>
            <p className='meeting-option'>{school?.code}</p>
            <p className='meeting-option'>{meetingGroup?.groupName}</p>
            <p className='meeting-option'>{meetingGroup?.meetingName}</p>
            <p className='meeting-option'>{school?.user?.full_name}</p>
            <p className='meeting-option'>{meetingGroup?.id}</p>
            <p className='meeting-option'>{setDate(meetingGroup?.meeting_date)}</p>
            <p className='meeting-option row-item'>
                <Link
                    title='Ver asistencia'
                    to={`/administrador/menu/asistencias/encuentro?encuentro=${meetingGroup?.id}`}>
                    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 29.756 19.837'>
                        <path
                            id='Icon_awesome-eye'
                            data-name='Icon awesome-eye'
                            d='M29.576,13.664A16.569,16.569,0,0,0,14.878,4.5,16.572,16.572,0,0,0,.18,13.665a1.671,1.671,0,0,0,0,1.508,16.569,16.569,0,0,0,14.7,9.164,16.572,16.572,0,0,0,14.7-9.165A1.671,1.671,0,0,0,29.576,13.664Zm-14.7,8.193a7.439,7.439,0,1,1,7.439-7.439A7.439,7.439,0,0,1,14.878,21.858Zm0-12.4a4.924,4.924,0,0,0-1.308.2,2.472,2.472,0,0,1-3.456,3.456,4.948,4.948,0,1,0,4.764-3.652Z'
                            transform='translate(0 -4.5)'
                            fill='#00904C'
                        />
                    </svg>
                </Link>
                <PrintAttendance school={school} meetingGroup={meetingGroup}></PrintAttendance>
            </p>
        </div>
    );
}

export default MeetingRow;
